import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getPlannedAtWorkoutUtil (workout) {
  return getValueReduxUtil(workout, WORKOUT_KEY.PLANNED_AT)
}

export default getPlannedAtWorkoutUtil
